export const part_interest_form_strings = {
  title: "Get more info",

  // Form sections
  interestedFilesTitle: "Interested File Categories",
  messageTitle: "Your Message",
  fileRequestDescription: "What information are you interested in?",

  // Form fields
  messageLabel: "Is there anything else we should know?",

  // File categories
  categoryPedigree: "Pedigree",
  categoryShopRelease: "Shop Release",
  categoryFlowTestReport: "Flow Test Report",
  categoryDimensionalInspection: "Dimensional Inspection",
  categoryNdeReport: "NDE Report",
  categoryPhoto: "Photos",

  // Buttons
  submitButton: "Contact the Team",
  next: "Next",
  back: "Back",

  // Stepper
  stepRequestDetails: "Request details",
  stepCompany: "Company information",

  // Validation messages
  validationRequired: "This field is required",
  validationMessageTooLong: "Message must be 2000 characters or less",

  // Warnings
  recentSubmissionWarning:
    "You recently requested information about this part.",

  submit_success_snackbar:
    "Request received. Our team will contact you within 1-2 business days.",
};

export const fileCategoryLables = [
  part_interest_form_strings.categoryPedigree,
  part_interest_form_strings.categoryShopRelease,
  part_interest_form_strings.categoryFlowTestReport,
  part_interest_form_strings.categoryDimensionalInspection,
  part_interest_form_strings.categoryNdeReport,
  part_interest_form_strings.categoryPhoto,
] as const;
